import { Component, Input, OnInit } from "@angular/core";
import { DownloadService } from "@merri/common";
import { take } from "rxjs/operators";
import { DownloadAllConfig } from "./models/download-all-config";

@Component({
    selector: "app-download-all",
    templateUrl: "./download-all.component.html",
    styleUrls: ["./download-all.component.scss"],
    standalone: false
})
export class DownloadAllComponent implements OnInit {
  processing: boolean;

  @Input() config: DownloadAllConfig;

  constructor(private _downloadService: DownloadService) {}

  ngOnInit(): void {}

  onDownloadClick(): void {
    this.processing = true;
    this._downloadService
      .downloadFilePost$(this.config.url, `${this.config.fileName}_${Date.now().toString()}.xlsx`, this.config.command)
      .pipe(take(1))
      .subscribe({
        next: () => (this.processing = false),
        error: () => (this.processing = false),
      });
  }
}
